"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ReportingCustomFieldsDocument", {
    enumerable: true,
    get: function() {
        return ReportingCustomFieldsDocument;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _fields = require("../fields");
const ReportingCustomFieldsDocument = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    type: _fields.CustomFieldTypes,
    options: _zod.z.array(_zod.z.string()).optional(),
    normalized_name: _zod.z.string().nullish(),
    deleted: _zod.z.boolean().optional(),
    vis: _zod.z.array(_fields.CustomFieldUserClass)
});
